import React, { useEffect, useRef, useState } from "react";
import "./css/SwapEsn.css";
import { api } from "../../../../../../../../../utility/AxiosInceptor";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import { PayInvoiceCheckIcon } from "../../../Payments/components/Payinvoice/components/PayInvoiceDialog/assets/PayInvoiceAsset";
import { Button } from "primereact/button";
import CommonLoaderBlue from "../../../../../../../../components/Loader/LoaderBlue";
import { Toast } from "primereact/toast";
export const SwapEsn = ({ cpData, setShowSwapEsn }) => {
  const toast = useRef();
  const [isSwapEsnLoading, setSwapEsnLoading] = useState(false);
  const [allesn, setAllEsn] = useState([]);

  useEffect(() => {
    api
      .get(
        `/api/web/simInventory/available?inventoryTypeId=${cpData?.inventoryId?._id}&carrier=${cpData?.carrier?._id}`
      )
      .then((response) => {
        setAllEsn(response?.data?.data);
      })
      .catch((err) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const formik = useFormik({
    validationSchema: Yup.object().shape({
      newesn: Yup.string().required("Field is Required"),
      //AgentName: Yup.string().required("Agent Name is required"),
    }),
    initialValues: {
      newesn: "",
      reuse: "TRUE",
      enrollmentId: cpData?._id,
    },
    onSubmit: async (values, { resetForm }) => {
      setSwapEsnLoading(true);
      api
        .post(`/api/user/SwapESN`, values)
        .then((res) => {
          toast.current.show({
            severity: "success",
            summary: "Info",
            detail: res?.data?.messsage || "ESN Swapped Successfully",
          });
          setSwapEsnLoading(false);
          setTimeout(() => {
            setShowSwapEsn((prev) => !prev);
          }, 500);
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Info",
            detail: err?.res?.data?.messsage || "ESN Swapping Failed",
          });
          setSwapEsnLoading(false);
        });
    },
  });
  return (
    <div
      style={{ width: "108.4rem" }}
      className="flex flex-wrap flex-row justify-content-center "
    >
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF99",
          top: 0,
          left: 0,
        }}
      ></div>
      <div className="swapesn-main">
        <div className="swapesn-top">
          <div className="header-swapesn">
            <h1>Swap ESN</h1>
            <p>Swap or reuse an ESN number to update this line's device.</p>
          </div>
          <div className="swapesn-statuschanging">
            <div className="dropdown-container-selectesn">
              <div className="flex flex-wrap w-full flex-row justify-content-between align-items-center">
                <label>Select ESN</label>
                <label className="p-error">
                  {formik.touched.newesn && formik.errors.newesn
                    ? formik.errors.newesn
                    : ""}
                </label>
              </div>
              <Dropdown
                options={allesn}
                name="newesn"
                onChange={formik.handleChange}
                optionLabel="SimNumber"
                value={formik.values.newesn}
                optionValue="SimNumber"
                // options={suspendStatusOptions}
                className={`dropdown-main ${formik.touched.newesn && formik.errors.newesn ? "p-invalid" : ""}`}
                placeholder="Select ESN"
              />
            </div>
            <div className="reuse-main-container">
              <h1>Reuse</h1>
              <div className="isreuse">
                <div className="esnreusestatus">
                  <div className="main-check-container">
                    {formik.values.reuse === "TRUE" ? (
                      <PayInvoiceCheckIcon />
                    ) : (
                      <div
                        className="main-check-wrapper"
                        onClick={() => {
                          formik.setFieldValue("reuse", "TRUE");
                        }}
                      >
                        <div
                          className={`${formik.values.reuse === "TRUE" ? "active-check-button" : ""}`}
                        ></div>
                      </div>
                    )}
                  </div>

                  <label>Yes</label>
                </div>
                <div className="esnreusestatus">
                  <div className="main-check-container">
                    {formik.values.reuse === "FALSE" ? (
                      <PayInvoiceCheckIcon />
                    ) : (
                      <div
                        className="main-check-wrapper"
                        onClick={() => {
                          formik.setFieldValue("reuse", "FALSE");
                        }}
                      >
                        <div
                          className={`${formik.values.reuse === "FALSE" ? "active-check-button" : ""}`}
                        ></div>
                      </div>
                    )}
                  </div>

                  <label>No</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="action-buttons-container flex flex-wrap flex-row justify-content-end">
          <Button
            disabled={isSwapEsnLoading}
            onClick={() => {
              setShowSwapEsn((prev) => !prev);
            }}
            label="Cancel"
          />
          <Button
            disabled={isSwapEsnLoading}
            onClick={formik.handleSubmit}
            label={
              isSwapEsnLoading ? (
                <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                  <CommonLoaderBlue sizehere={12} color={"white"} />
                </div>
              ) : (
                "Swap"
              )
            }
          />
        </div>
      </div>
      <Toast ref={toast} />
    </div>
  );
};
